<template>
  <div class="rodemap">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: 'cv-03',
          word:
            '御景亭在整个御花园东侧的假山顶上。原是明代观花殿的旧址，万历间改堆假山。御景亭是皇帝、皇后重阳节登高的地方，亭上可俯瞰宫苑，远眺紫禁城、景山，整个西苑尽在目中。',
          audio: 'aj',
          scene: 'scene9',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/aj/08');
        this.index--;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/御景亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
